import Modal from "@/components/design-system/Modal";
import React from "react";
import FilePreview from "./FilePreview";

interface PreviewFileModalProps {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string;
  fileType: "video" | "audio" | "pdf" | "docx" | "unknown" | string;
}

const PreviewFileModal: React.FC<PreviewFileModalProps> = ({
  isOpen,
  onClose,
  fileUrl,
  fileType,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Preview`}
      width="1100px"
      contentClassName="p-0 overflow-hidden"
    >
      <div className="p-0 flex flex-col">
        <div className="flex justify-center bg-gray-100">
          <FilePreview fileUrl={fileUrl} fileType={fileType} />
        </div>
      </div>
    </Modal>
  );
};

export default PreviewFileModal;
